import styles from "../landing-page-four.module.css";
import { usePaths } from "BEDROCK/paths";

export const FooterSection = () => {
  const { navigateTo, terms, privacyPolicy, cookiePolicy } = usePaths();

  const goTo = (path: string) => {
    navigateTo(path);
  };

  return (
    <div className={styles.footerContainer}>
      <div className={styles.footerTopRow}>
        <div className={styles.footerLeading}>
          <FooterLink title="FAQ" url="https://articles.trailart.store/FAQ" />
          <FooterLink title="Terms & Conditions" onClick={() => goTo(terms)} />
          <FooterLink
            title="Privacy Policy"
            onClick={() => goTo(privacyPolicy)}
          />
          <FooterLink
            title="Cookie Policy"
            onClick={() => goTo(cookiePolicy)}
          />
        </div>
        <div className={styles.footerSeparator} />
        <div className={styles.footerTrailing}>
          <FooterLink
            title="Contact Us"
            onClick={() =>
              window.open("mailto:support@trailart.store", "_blank")
            }
          />
        </div>
      </div>
      <div className={styles.footerBottomRow}>
        <InstaButton />
      </div>
    </div>
  );
};

interface FooterLinkProps {
  title: string;
  url?: string;
  onClick?: () => void;
}

const FooterLink = (props: FooterLinkProps) => {
  if (props.url) {
    return (
      <a
        className={styles.footerLink}
        href={props.url}
        target="_blank"
        rel="noreferrer"
      >
        {props.title}
      </a>
    );
  }

  return (
    <button className={styles.footerLink} onClick={props.onClick}>
      {props.title}
    </button>
  );
};

const InstaButton = () => {
  return (
    <a
      href="https://www.instagram.com/trailart.store/"
      className={styles.instaButton}
      target="_blank"
      rel="noreferrer"
    >
      <img
        src="/landing-page/shared/insta-qr-3.png"
        alt="Follow us on Instagram"
      />
    </a>
  );
};
